"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NUMBERVALUE = void 0;
const tab_1 = require("../../../tab");
exports.NUMBERVALUE = {
    description: 'Converts text to a number, in a locale-independent way',
    arg_names: ['text', 'decimal_separator'],
    args_def: [
        {
            types: ['string'],
            required: true,
        },
        {
            types: ['string'],
            required: true,
        },
    ],
    args_description: [
        'The text to convert to a number',
        'The character used to separate the integer and fractional part of the result',
    ],
    return_type: tab_1.ColumnType.NUMBER,
};
